import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WindowTitle = _resolveComponent("WindowTitle")!
  const _component_ChangingNumber = _resolveComponent("ChangingNumber")!
  const _component_White = _resolveComponent("White")!
  const _component_WindowContent = _resolveComponent("WindowContent")!
  const _component_Window = _resolveComponent("Window")!

  return (_openBlock(), _createBlock(_component_Window, { class: "dashboard-comms" }, {
    default: _withCtx(() => [
      _createVNode(_component_WindowTitle, null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(" Comms ")
        ])),
        _: 1,
        __: [0]
      }),
      _createVNode(_component_WindowContent, null, {
        default: _withCtx(() => [
          _createElementVNode("table", null, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[3] || (_cache[3] = _createElementVNode("td", null, " #milliways@hackint ", -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_White, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ChangingNumber, {
                        min: 1,
                        max: 25,
                        precision: 2
                      }),
                      _cache[1] || (_cache[1] = _createTextVNode(" Tbps down / ")),
                      _createVNode(_component_ChangingNumber, {
                        min: 1,
                        max: 25,
                        precision: 2
                      }),
                      _cache[2] || (_cache[2] = _createTextVNode(" Tbps up "))
                    ]),
                    _: 1,
                    __: [1,2]
                  })
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}